import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { href: "/#how", label: "How it works" },
  { href: "/#menu", label: "Menu" },
  { href: "/hostamachine", label: "Host a Machine" },
  { href: "/#book", label: "Book for Event" },
  { href: "/#faq", label: "FAQ" },
];

export default function Nav() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const on = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", on);
    return () => window.removeEventListener("scroll", on);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,border-color] duration-300 ${
        scrolled
          ? "bg-black/70 backdrop-blur-xl border-b border-white/10"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 flex items-center justify-between h-16 md:h-20">
        <a
          href="#top"
          data-testid="nav-logo"
          className="flex items-center gap-2"
        >
          <img
            src="/frostico-logo.png"
            alt="Frostico"
            className="h-11 md:h-14 w-auto"
          />
        </a>
        <nav className="hidden md:flex items-center gap-10 font-mono-accent text-[11px] text-white/70">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.href.replace("#", "")}`}
              className="hover:text-white transition-colors duration-200"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <a
          href="/hostamachine"
          data-testid="nav-cta-button"
          className="hidden md:inline-flex items-center gap-2 rounded-full border border-[#8B5CF6] bg-[#8B5CF6] px-5 py-2.5 text-sm font-semibold text-white transition-transform duration-200 hover:-translate-y-0.5 neon-glow-pink"
        >
          Pre-book Now
        </a>
        <button
          data-testid="nav-menu-toggle"
          className="md:hidden text-white p-2"
          onClick={() => setOpen((v) => !v)}
          aria-label="Open menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
      {open && (
        <div className="md:hidden bg-black/90 backdrop-blur-xl border-t border-white/10 px-6 py-6 space-y-4">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="block font-mono-accent text-xs text-white/70 hover:text-white"
            >
              {l.label}
            </a>
          ))}
          <a
            href="/hostamachine"
            onClick={() => setOpen(false)}
            className="block text-center rounded-full bg-[#8B5CF6] px-5 py-3 text-sm font-semibold text-white"
          >
            Pre-book Now
          </a>
        </div>
      )}
    </header>
  );
}
